<template>
<div class="columns">
    <data-view v-on:delete-data="deleteData" v-on:update-data="updateData" v-for="data in dataList" :data="data" v-bind:key="data.key" class="column is-6 box" v-bind:class="isActive(data.status)"></data-view>
</div>
</template>

<style scoped>
.box{
    border: 1px solid #ccc;
}
.active{
    border: 1px solid rgb(6, 50, 247);
}
</style>
<script>
import DataView from './DataView';
import axios from 'axios'
import { ToastProgrammatic as Toast } from 'buefy'

export default {
    data() {
        return {
            input: {
            },
            data : {
                repeatOn : []
            },
            result: "",
        };
    },
    props: ['dataList'],
    components: {
        DataView,
    },
    methods: {
        isActive(myStatus){
            if (myStatus == 1){
                return "active"
            }else{
                return ""
            }
        },
        deleteData(data) {
            let self = this;
            
            this.$swal({
                title: "Are you sure? ",
                text: "Class/Department " + data.level + " " + data.name + " and ALL STUDENTS/USERS AND THEIR SUBMISSIONS UNDER IT will be PERMANENTLY REMOVED!  To continue, enter 'DELETE CLASS " + data.name + "' in the text field below and press OK",
                input: 'text',
                showCancelButton: true,
                inputValidator: (value) => {
                    if (value == "DELETE CLASS " + data.name){
                        const dataIndex = this.dataList.indexOf(data);
                        this.dataList.splice(dataIndex, 1);

                        axios.defaults.responseType = 'json'
                        axios.post(process.env.NEW_ENDPOINT + '/classes/remove/', {
                            token: localStorage.getItem('jwtTokenV2'),
                            email: localStorage.getItem('email'),
                            _id: data._id,
                        }).then(response => {
                            if (response.data.success == false) {
                                Toast.open({
                                    message: response.data.msg,
                                    type: 'is-danger', //is-white, is-black, is-light, is-dark, is-primary, is-info, is-success, is-warning, is-danger
                                    duration: 5000
                                })
                            } else {
                                Toast.open({
                                    message: response.data.msg,
                                    type: 'is-success',
                                    duration: 3000
                                })
                            }
                        })
                        .catch(e => {
                            console.log(e.response)
                            if (e.response.status === 401) {
                                console.log("salah login")
                                Toast.open({
                                    message: "Unauthorized access. Please re-login.",
                                    type: 'is-danger', //is-white, is-black, is-light, is-dark, is-primary, is-info, is-success, is-warning, is-danger
                                    duration: 10000
                                })
                            } else {
                                Toast.open({
                                    message: e,
                                    type: 'is-danger', //is-white, is-black, is-light, is-dark, is-primary, is-info, is-success, is-warning, is-danger
                                    duration: 10000
                                })
                            }
                        })
                    }else{
                        Toast.open({
                            message: "You entered the wrong input. Class/Department is not removed.",
                            type: 'is-danger', //is-white, is-black, is-light, is-dark, is-primary, is-info, is-success, is-warning, is-danger
                            duration: 3000
                        })
                    }
                    //return !value && 'You need to write something!'
                }
            });
        },

        updateData(data) {
            let self = this;

            var level = data.level;
            var name = data.name;
            var teachers = data.teachers;
            var status = data.status;

            if (level.length < 1){
                Toast.open({
                    message: "Please enter the class/department level",
                    type: 'is-danger', //is-white, is-black, is-light, is-dark, is-primary, is-info, is-success, is-warning, is-danger
                    duration: 3000
                })
                return false;
            }else{
                level = level.trim()
            }
            if (name.length < 1){
                Toast.open({
                    message: "Please enter the class/department name",
                    type: 'is-danger', //is-white, is-black, is-light, is-dark, is-primary, is-info, is-success, is-warning, is-danger
                    duration: 3000
                })
                return false;
            }else{
                name = name.trim()
            }
            if (status){
                status = parseInt(status)
            }else{
                status = 0
            }

            axios.defaults.responseType = 'json'
            axios.post(process.env.NEW_ENDPOINT + '/classes/update/', {
                token: localStorage.getItem('jwtTokenV2'),
                email: localStorage.getItem('email'),
                _id: data._id,
                level: level,
                name: name,
                teachers: teachers,
                status: status                
            })
            .then(response => {
                if (response.data.success == false) {
                    Toast.open({
                        message: response.data.msg,
                        type: 'is-danger', //is-white, is-black, is-light, is-dark, is-primary, is-info, is-success, is-warning, is-danger
                        duration: 5000
                    })
                } else {
                    Toast.open({
                        color: 'is-dark', //is-white, is-black, is-light, is-dark, is-primary, is-info, is-success, is-warning, is-danger
                        message: response.data.msg,
                        type: 'is-success',
                        duration: 3000
                    })
                }
            })
            .catch(e => {
                if (e.response.status === 401) {                            
                    Toast.open({
                        message: "Unauthorized access. Please re-login.",
                        type: 'is-danger', //is-white, is-black, is-light, is-dark, is-primary, is-info, is-success, is-warning, is-danger
                        duration: 5000
                    })
                } else {
                    Toast.open({
                        message: 'Error: ' + e.response.data.msg,
                        type: 'is-danger', //is-white, is-black, is-light, is-dark, is-primary, is-info, is-success, is-warning, is-danger
                        duration: 5000
                    })
                }
            })           
        },
    },
};
</script>


// WEBPACK FOOTER //
// src/components/Manage/Classes/DataList.vue